import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { Article } from '../../admin/shared/public-api';
import { removeTags } from '../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class JSONLDService {
  scriptType = 'application/ld+json';
  constructor(@Inject(DOCUMENT) private _document: Document) {}

  removeStructuredData(): void {
    const els: any[] = [];
    ['structured-data-website', 'structured-data-org'].forEach((c) => {
      els.push(...Array.from(this._document.head.getElementsByClassName(c)));
    });
    els.forEach((el) => this._document.head.removeChild(el));
  }

  insertSchema(article?: Article): void {
    const schema = this.generateSchema(article);
    const className = 'structured-data-website';
    let script: HTMLScriptElement;
    let shouldAppend = false;
    if (this._document.head.getElementsByClassName(className).length) {
      script = this._document.head.getElementsByClassName(className)[0] as HTMLScriptElement;
    } else {
      script = this._document.createElement('script');
      shouldAppend = true;
    }
    script.setAttribute('class', className);
    script.type = this.scriptType;
    script.text = JSON.stringify(schema);
    if (shouldAppend) {
      this._document.head.appendChild(script);
    }
  }

  private generateSchema(article?: Article): any {
    const baseUrl = 'https://lesexplorateursdumonde.com/';

    const graph: any = {
      '@type': 'BlogPosting',
      name: 'Les Explorateurs du Monde',
      image: {
        '@type': 'ImageObject',
        url: 'https://lesexplorateursdumonde.com/og_img.png',
      },
      description: 'Blog voyages belge, découvertes et aventures en Belgique et dans le monde',
      mainEntityOfPage: baseUrl,
      publisher: this.generateOrgSchema(),
      author: this.generateOrgSchema(),
    };

    if (article) {
      const url = `${baseUrl}/${article.slug}`;
      graph.mainEntityOfPage = url;
      graph.headline = article.name;
      graph.image.url = `${baseUrl}/${article.coverPicture?.src}`;
      graph.description = removeTags(article.description);
    }

    return {
      '@context': 'https://schema.org',
      '@graph': [graph],
    };
  }

  private generateOrgSchema(): any {
    return {
      '@type': 'Organization',
      url: 'https://lesexplorateursdumonde.com',
      name: 'Les Explorateurs du monde',
      logo: {
        '@type': 'ImageObject',
        url: 'https://lesexplorateursdumonde.com/assets/logo_black.png',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'explorateurs@lesexplorateursdumonde.com',
      },
    };
  }
}
